import axios from "axios";
import * as myConstClass from "../Config/config.js";
import { Encrypt, Decrypt, Appsflyer, branchIO } from "../Helpers/Common"; //Include Home
const END_POINT = myConstClass.BACKEND_ENDPOINT;
const AUTH_TOKEN = myConstClass.AUTH_TOKEN;

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": true,
  "x-access-auth-token": "" + AUTH_TOKEN + "",
};

export async function ChangePassword(postdata) {
  // Appsflyer("change Password", postdata);
  // branchIO("change Password", postdata)
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/change-password", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function ResetPassword(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/resetpassword", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}
//Get user details
export async function getSignUp(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/signup", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function SendLogoutpin(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/send-logout-pin", "postData", {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function verifylogout(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/verify-logout-pin", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}
export async function Mangedevices(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/manage-devices", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function Usernotification(postdata) {
  return await Encrypt(postdata).then(async (res) => {
    const postData = {
      digest: res,
    };
    const res_2 = await axios
      .post(END_POINT + "/users/notifications", postData, {
        headers: headers,
      });
    const data = res_2;
    return data;
  });
}

/*-----Generate Pin--------------*/

export async function Generatepinm(req) {
  return await Encrypt(req).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/generatepin", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function getLogin(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };

    return axios
      .post(END_POINT + "/users/login", postData, {
        headers: headers,
        withCredentials: true,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function onboardLogin(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/onboard", postData, {
        headers: headers,
        // withCredentials: true,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function onboardLoginOTP(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/verifyotp", postData, {
        headers: headers,
        // withCredentials: true,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function Getotp(postdata) {
  return await Encrypt(postdata).then(async (res) => {
    const postData = {
      digest: res,
    };
    const res_2 = await axios
      .post(END_POINT + "/users/getotp", postData, {
        headers: headers,
      });
    const data = res_2;
    return data;
  });
}

export async function VerifyPin(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/verifypin", postData, {
        headers: headers,
      })
      .then((response) => {
        return response;
      });
  });
}

export async function Sendpin(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/sendpin", postData, {
        headers: headers,
      })
      .then((response) => {
        return response;
      });
  });
}

export async function UserchangeSendpin(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/userchange-sendpin", postData, {
        headers: headers,
      })
      .then((response) => {
        return response;
      });
  });
}

export async function Userregistercheck(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/checkuser", postData, {
        headers: headers,
      })
      .then((response) => {
        return response;
      });
  });
}

export async function Checkregisterusers(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/checkaccount", postData, {
        headers: headers,
      })
      .then((response) => {
        return response;
      });
  });
}

//Check User if exist or not
export async function CheckUser() {
  var EncryptedData = JSON.parse(localStorage.getItem("user-info"));

  if (EncryptedData != null) {
    return await Decrypt(EncryptedData).then((res) => {
      var UserData = res;
      return UserData;
    });
  } else {
    return null;
  }
}

//Get User data
export async function getUser(postdata) {
  return await axios
    .post(
      END_POINT + "/users/login",
      { fld_email: postdata.fld_email, fld_password: postdata.fld_password },
      {
        headers: headers,
      }
    )
    .then((res) => {
      const data = res;
      return data;
    });
}

//Logout and clear localstorages

export async function logout(data) {
  return await axios
    .post(END_POINT + "/users/logout", data, {
      headers: headers,
    })
    .then((res) => {
      localStorage.clear();
      const data = res;
      return data;
    });
}

export async function userprofile(data) {
  return await axios
    .post(END_POINT + "/users/profile", data, {
      headers: headers,
    })
    .then((res) => {
      const data = res;
      return data;
    });
}

export async function userprofileEth(data) {
  return await axios
    .post(END_POINT + "/users/ethprofile", data, {
      headers: headers,
    })
    .then((res) => {
      const data = res;
      return data;
    });
}

export async function UpdateProfile(postData) {
  return await axios.post(END_POINT + "/users/profile-update", postData, {
    headers: headers,
  }).then((res) => {
    const data = res;
    return data;
  });
}

/*-------------Verify The current pass --------------*/

export async function VefifycurrentPass(Postdata) {
  return await Encrypt(Postdata).then(async (res) => {
    const postData = {
      digest: res,
    };

    const res_2 = await axios
      .post(END_POINT + "/users/verify-current-pass", postData, {
        headers: headers,
      });
    const data = res_2;
    return data;
  });
}

/*-------------Verify The current pass --------------*/

export async function RemoveNoti(Postdata) {
  return await Encrypt(Postdata).then(async (res) => {
    const postData = {
      digest: res,
    };

    const res_2 = await axios
      .post(END_POINT + "/users/update-notification-status", postData, {
        headers: headers,
      });
    const data = res_2;
    return data;
  });
}

export async function Addtowatchlistaction(postdata) {
  // Appsflyer("Add Watchlater", postdata);
  // branchIO("Add Watchlater", postdata)
  var newObject = {
    action: postdata.action,
    x_country: postdata.x_country,
    is_child: postdata.is_child,
    seesionID: localStorage.getItem("session_id"),
    userID: localStorage.getItem("userID"),
    content_id: postdata.content_id,
    clear: postdata.clear
  }
  return await Encrypt(newObject).then(async (res) => {
    const postData = {
      digest: res,
    };
    const res_2 = await axios.post(END_POINT + "/content/watchlater", postData, {
      headers: headers,
    });
    const data = res_2;
    return data;
  });
}

export async function Checkuserwatchlist(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/user-watched-check", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function Removecontinuewatch(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/removecontinuewatcing", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function RemoveallcontinueWatching(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/content/removeAllContinueWatching", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function Verifyemailmobile(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/verify/emailmobile", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function Tvapppinvalidate(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/tvapppin", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}
export async function SendNewletter(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/newsletter", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function SendContactUs(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/contactus", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

export async function deleteAccount(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/users/deleteaccount", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}

//@Definition: This function is used for utm User Tracking.
export async function utmTracking(data) {
  return axios.post(END_POINT + "/users/utmTracking", data, {
    headers: headers,
  })
    .then((response) => {
      return response;
    });
}

export async function getGeoInfo() {
  return axios
    .get("https://newuiprod-dbapi.docubay.com/1x1trans.png")
    .then((response) => {
      let data = response.headers["x-cc"];
      return data;
    })
    .catch((error) => {
      console.log(error);
    });
}
